'use client'
import { Toaster } from '@repo/ui/components'
import React from 'react'

interface ToastProviderProps {
  children: React.ReactNode
}

export const ToastProvider = (props: ToastProviderProps) => {
  const { children } = props
  return (
    <>
      <Toaster position='top-center' />
      {children}
    </>
  )
}
